import React from 'react';
import DotAnimation from '../../molecules/dot-animation/dot-animation';
import './spinner.css';

interface SpinnerProps {
  className?: string;
  color?: 'white' | 'blue';
}
const Spinner: React.FC<SpinnerProps> = ({ className, color = 'white' }) => {
  return (
    <div className={`spinner ${className}`}>
      <span className='button-text'>Einen Moment</span>
      <DotAnimation color={color} />
    </div>
  );
};

export default Spinner;
